/**
 * FinanceCard — a clickable card for the Dashboard's finance summary section.
 *
 * Same look-and-feel pattern as MetricCard but with a sub-label and currency-style value.
 */
export const FinanceCard = ({ testid, bg, icon: Icon, label, sub, value, onClick }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className="text-left border-2 border-black rounded-md p-4 shadow-[4px_4px_0px_0px_rgba(163,230,53,0.4)] hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(163,230,53,0.6)] transition-all cursor-pointer"
    style={{ backgroundColor: bg }}
  >
    <div className="flex items-start justify-between mb-3">
      <Icon size={28} weight="duotone" />
    </div>
    <div className="text-2xl font-black text-black mb-1">{value}</div>
    <div className="text-xs font-bold uppercase tracking-wider text-black">{label}</div>
    <div className="text-xs text-black font-medium mt-1 opacity-70">{sub}</div>
  </button>
);
